import { conversationCreate, conversationUpdate, conversationDelete } from "./conversationApi";
import { sessionView } from "../../lib/bandung/api/session";

export const conversationCreateAction = async ({ request }) => {
  const formData = await request.formData();
  const userEntityRes = await sessionView();
  const submission = {
    userEntityId: userEntityRes?.data.userEntityId,
    label: formData.get("label"),
    name: formData.get("name"),
    order: formData.get("order"),
    shortDescription: formData.get("shortDescription"),
    longDescription: formData.get("longDescription"),
  };

  const res = await conversationCreate(submission);
  return res;
};

export const conversationUpdateAction = async ({ request }) => {
  try {
    const formData = await request.formData();
    const submission = {
      conversationEntityId: formData.get("conversationEntityId"),
      label: formData.get("label"),
      name: formData.get("name"),
      shortDescription: formData.get("shortDescription"),
      longDescription: formData.get("longDescription"),
    };
    const res = await conversationUpdate(submission);
    return res;
  } catch (error) {
    console.error("Error in conversation update action:", error);
    return {
      code: "ERROR",
      message: "An error occurred while updating the conversation.",
    };
  }
};

export const conversationDeleteAction = async ({ request }) => {
  try {
    const formData = await request.formData();

    const submission = {
      conversationEntityId: formData.get("conversationEntityId"),
    };

    const res = await conversationDelete(submission);

    return res;
  } catch (error) {
    console.error("Error in conversation delete action:", error);
    return {
      code: "ERROR",
      message: "An error occurred while deleting the conversation.",
    };
  }
};
